export default __webpack_public_path__ + "static/media/information.5212265b.svg";